module.exports = __webpack_public_path__ + "static/img/case-solution-diagram-01.78090fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-solution-diagram-01.png
// module id = MBKb
// module chunks = 1